import { BaseModel } from './base.model';
import { Expose, Type } from 'class-transformer';
import { IGroup, IViewGroup } from '../interfaces';
import { Permission } from './permission.model';

export class GroupModel extends BaseModel implements IGroup {
  @Expose()
  id!: number;

  @Expose()
  name!: string;

  @Expose()
  slug!: string;

  @Expose()
  role!: string;

  @Expose()
  scope!: 'bu' | 'own';

  @Expose()
  tag!: string[];

  @Expose()
  @Type(() => Permission)
  permissions!: Permission[];

  @Expose()
  viewPolicy?: {
    policy: string[];
  };
}

export class ViewGroupModel extends BaseModel implements IViewGroup {
  @Expose()
  id!: number;

  @Expose()
  name!: string;

  @Expose()
  slug!: string;

  @Expose()
  status!: string;

  @Expose()
  @Type(() => GroupModel)
  groups!: GroupModel[];

  @Expose()
  viewPolicy!: {
    policy: string[];
  };
}
